import { Flags } from '@constants/flags';
import type { WithdrawalMode } from '@generated/graphql';
import { useFlag } from '@onevesthq/feature-flags/web';
import { isWithdrawalFeatureActive } from './withdrawalMode.utils';

export type UseWithdrawalFeatureActiveProp = {
  optionEnabled: boolean;
  storedMode: WithdrawalMode | undefined;
  netAmountCents: number | undefined;
};

export const useWithdrawalFeatureActive = ({
  optionEnabled,
  storedMode,
  netAmountCents,
}: UseWithdrawalFeatureActiveProp) => {
  const { enabled: flagEnabled } = useFlag(Flags.withdrawal_net_gross, {
    default: false,
  });

  return isWithdrawalFeatureActive({
    flagEnabled,
    optionEnabled,
    storedMode,
    netAmountCents,
  });
};
